function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBronzeBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 11.9996,
    cy: 9.0001,
    r: 7.15,
    fill: "#CD7F32",
    fillOpacity: 0.3,
    style: {
      fill: "#CD7F32",
      fill: "color(display-p3 0.8039 0.4980 0.1961)",
      fillOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M16.596 14.4773C18.0487 13.2584 18.9576 11.5123 19.1229 9.62326C19.2882 7.73418 18.6962 5.85682 17.4773 4.40417C16.2584 2.95152 14.5123 2.04258 12.6233 1.87731C10.7342 1.71203 8.85682 2.30396 7.40417 3.52288L12.0001 9.0001L16.596 14.4773Z",
    fill: "#CD7F32",
    fillOpacity: 0.4,
    style: {
      fill: "#CD7F32",
      fill: "color(display-p3 0.8039 0.4980 0.1961)",
      fillOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5963 19.7062L18.9675 14.0737C20.01 12.6487 20.625 10.8938 20.625 9C20.625 4.245 16.755 0.375 12 0.375C7.24502 0.375 3.37502 4.245 3.37502 9C3.37502 10.8938 3.99002 12.6487 5.03252 14.0737L2.40377 19.7062C2.28752 19.9575 2.31752 20.25 2.48627 20.4713C2.65127 20.6925 2.92502 20.805 3.19877 20.7638L6.71252 20.2275L8.56127 23.265C8.69627 23.49 8.94002 23.625 9.20252 23.625H9.24377C9.52127 23.61 9.76502 23.4412 9.88127 23.1937L12 18.6488L14.1188 23.1937C14.235 23.4412 14.4788 23.61 14.7563 23.625H14.7975C15.06 23.625 15.3038 23.49 15.4388 23.265L17.2875 20.2275L20.8013 20.7638C21.075 20.805 21.3488 20.6925 21.5138 20.4713C21.6825 20.25 21.7125 19.9575 21.5963 19.7062ZM12 16.125C8.07002 16.125 4.87502 12.93 4.87502 9C4.87502 5.07 8.07002 1.875 12 1.875C15.93 1.875 19.125 5.07 19.125 9C19.125 12.93 15.93 16.125 12 16.125Z",
    fill: "#CD7F32",
    style: {
      fill: "#CD7F32",
      fill: "color(display-p3 0.8039 0.4980 0.1961)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0103 13.6193C11.425 13.6193 10.9023 13.5185 10.4421 13.3168C9.98469 13.1151 9.62248 12.8352 9.35543 12.4773C9.09123 12.1165 8.94918 11.6989 8.9293 11.2244H10.2674C10.2844 11.483 10.3711 11.7074 10.5273 11.8977C10.6864 12.0852 10.8938 12.2301 11.1495 12.3324C11.4051 12.4347 11.6892 12.4858 12.0017 12.4858C12.3455 12.4858 12.6495 12.4261 12.9137 12.3068C13.1807 12.1875 13.3895 12.0213 13.5401 11.8082C13.6907 11.5923 13.7659 11.3438 13.7659 11.0625C13.7659 10.7699 13.6907 10.5128 13.5401 10.2912C13.3924 10.0668 13.175 9.89062 12.8881 9.76278C12.604 9.63494 12.2603 9.57102 11.8569 9.57102H11.1196V8.49716H11.8569C12.1807 8.49716 12.4648 8.43892 12.7091 8.32244C12.9563 8.20597 13.1495 8.04403 13.2887 7.83665C13.4279 7.62642 13.4975 7.38068 13.4975 7.09943C13.4975 6.82955 13.4364 6.59517 13.3142 6.39631C13.1949 6.1946 13.0245 6.03693 12.8029 5.9233C12.5841 5.80966 12.3256 5.75284 12.0273 5.75284C11.7432 5.75284 11.4776 5.8054 11.2304 5.91051C10.9861 6.01278 10.7873 6.16051 10.6338 6.35369C10.4804 6.54403 10.398 6.77273 10.3867 7.03977H9.11254C9.12674 6.56818 9.26594 6.15341 9.53015 5.79545C9.79719 5.4375 10.1495 5.15767 10.587 4.95597C11.0245 4.75426 11.5103 4.65341 12.0444 4.65341C12.604 4.65341 13.087 4.76278 13.4932 4.98153C13.9023 5.19744 14.2176 5.4858 14.4392 5.84659C14.6637 6.20739 14.7745 6.60227 14.7716 7.03125C14.7745 7.51989 14.6381 7.93466 14.3625 8.27557C14.0898 8.61648 13.7262 8.84517 13.2716 8.96165V9.02983C13.8512 9.1179 14.3 9.34801 14.6182 9.72017C14.9392 10.0923 15.0983 10.554 15.0955 11.1051C15.0983 11.5852 14.9648 12.0156 14.6949 12.3963C14.4279 12.777 14.0628 13.0767 13.5998 13.2955C13.1367 13.5114 12.6069 13.6193 12.0103 13.6193Z",
    fill: "#BB732B",
    style: {
      fill: "#BB732B",
      fill: "color(display-p3 0.7325 0.4493 0.1698)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBronzeBadge);
export default __webpack_public_path__ + "static/media/BronzeBadge.0a68250274836a69cbc7f00b16a34a46.svg";
export { ForwardRef as ReactComponent };